import { Controller } from "@hotwired/stimulus"
import { Chart, registerables } from "chart.js"

Chart.register(...registerables)

export default class extends Controller {
  static values = {
    labels: Array,
    subscribed: Array,
    confirmed: Array,
    unsubscribed: Array
  }

  connect() {
    this.initChart()

    // Handle Turbo cache - destroy chart before page is cached
    this.beforeCacheHandler = this.teardown.bind(this)
    document.addEventListener("turbo:before-cache", this.beforeCacheHandler)
  }

  disconnect() {
    document.removeEventListener("turbo:before-cache", this.beforeCacheHandler)
    this.teardown()
  }

  initChart() {
    // Destroy existing chart if any
    if (this.chart) {
      this.chart.destroy()
    }

    const ctx = this.element.getContext("2d")

    this.chart = new Chart(ctx, {
      type: "line",
      data: {
        labels: this.labelsValue,
        datasets: [
          {
            label: "Zapisani",
            data: this.subscribedValue,
            borderColor: "rgb(59, 130, 246)",
            backgroundColor: "rgba(59, 130, 246, 0.1)",
            tension: 0.3,
            fill: true
          },
          {
            label: "Potwierdzeni",
            data: this.confirmedValue,
            borderColor: "rgb(34, 197, 94)",
            backgroundColor: "rgba(34, 197, 94, 0.1)",
            tension: 0.3,
            fill: true
          },
          {
            label: "Wypisani",
            data: this.unsubscribedValue,
            borderColor: "rgb(239, 68, 68)",
            backgroundColor: "rgba(239, 68, 68, 0.1)",
            tension: 0.3,
            fill: true
          }
        ]
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: {
            position: "bottom"
          }
        },
        scales: {
          y: {
            beginAtZero: true,
            ticks: {
              stepSize: 1
            }
          }
        }
      }
    })
  }

  teardown() {
    if (this.chart) {
      this.chart.destroy()
      this.chart = null
    }
  }
}
